module.exports = __webpack_public_path__ + "assets/b0337b48775b588672fc9dc3ea837eca.mp3";